<template>
  <div class="layout-container">
    <header>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Wrona School</title>
      <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet" crossorigin="anonymous">
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css">
    </header>
    <main class="main-content">
      <router-view />
    </main>
    <FooterComponent/>
  </div>
</template>

<script>
import FooterComponent from './FooterComponent.vue';
export default {
    name: 'LayoutComponent',
    components: {
        FooterComponent
    }
};
</script>

<style>
.layout-container {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>